<p-toast></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-contextMenu #cm [model]="menuContextuel"></p-contextMenu>


<p-card *ngIf="!EstCharge()">
	<div class="fluid formgrid grid">
		<div class="flex flex-column gap-2 col-12 text-center">
			<p-progressSpinner></p-progressSpinner>
		</div>
	</div>
</p-card>

<div class="grid" *ngIf="EstCharge()">
    <div class="col-12">

        <p-card>
            <div class="grid">
                <div class="col-6">
                    <h5>Approbation des listes d'achat</h5>
                </div>
            </div>
            <p-table #dt [value]="listes" dataKey="listeAchatId" tableStyleClass="tableNormale" autoLayout="true"
                 [(contextMenuSelection)]="selectionListe"
                [contextMenu]="cm" [rowHover]="true" [rows]="25" [paginator]="true" [filterDelay]="0"
                [globalFilterFields]="['nom','description']">
                <ng-template pTemplate="caption">
                    <div class="grid">
                        <div class="col-6">
                            <span class="p-input-icon-left">
                                <i class="pi pi-search"></i>
                                <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                                    placeholder="Recherche..." />
                            </span>
                        </div>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                       
                        <th pSortableColumn="dateSaisie">
                            <div class="flex justify-content-between align-items-center">
                                Date
                                <p-sortIcon field="dateSaisie"></p-sortIcon>
                                <p-columnFilter type="date" field="dateSaisie" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="nom">
                            <div class="flex justify-content-between align-items-center">
                                Nom
                                <p-sortIcon field="nom"></p-sortIcon>
                                <p-columnFilter type="text" field="nom" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="statut">
                            <div class="flex justify-content-between align-items-center">
                                Statut
                                <p-sortIcon field="statut"></p-sortIcon>
                                <p-columnFilter type="text" field="statut" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="employe">
                            <div class="flex justify-content-between align-items-center">
                                Saisi par
                                <p-sortIcon field="employe"></p-sortIcon>
                                <p-columnFilter type="text" field="employe" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th style="min-width: 4rem"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-liste >
                    <tr [pContextMenuRow]="liste">
                        <td>{{liste.dateSaisie | date:'yyyy-MM-dd'}}</td>
                        <td>{{liste.modele?.nom}}</td>
                        <td><span [class]="'statut ' + liste.statut.nom.replace(' ','').toLowerCase()">
                                    {{liste.statut.nom}}
                                </span></td>
                        <td><app-employe-avec-emplacement [employe]="liste.employe"></app-employe-avec-emplacement></td>
                        <td>
                            <button *ngIf="liste.statut.statutId == 6" pButton pRipple icon="pi pi-eye" class="p-button-success mr-2 boutonGrille"
                                (click)="OuvrirDetailListeAchat(liste.listeAchatId)"></button>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="4">Aucune liste d'achat.</td>
                    </tr>
                </ng-template>
            </p-table>
            
        </p-card>
    </div>


</div>